<template>
  <div>
    <div class="modal fade show modal-mask" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ selected_item.name_code }})</h5>

            <button @click="close_add_note" type="button" class="close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Notes</label>
              <textarea v-model="notes"></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button
              @click.prevent="delete_note_line"
              @keyup.enter.prevent="delete_note_line"
              type="button"
              class="btn btn-sm btn-outline-danger"
            >
              Delete
            </button>
            <button
              @click.prevent="add_note_line"
              @keyup.enter.prevent="add_note_line"
              type="button"
              class="btn btn-sm btn-outline-success"
            >
              Save
            </button>
            <button
              @click="close_add_note"
              type="button"
              class="btn btn-sm btn-outline-secondary"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "order_management_add_note",
  data() {
    return {
      notes: this.selected_item.notes,
    };
  },
  props: {
    selected_item: Object,
  },
  methods: {
    close_add_note() {
      this.$emit("close_add_note");
    },
    add_note_line: async function () {
      const send_notes = this.notes || null;
      console.log("add_note_line modal function");
      console.log("notes sending: " + send_notes);

      //   console.log(this.selected_item.id);
      this.$emit("update_note", send_notes);

      //   this.close_add_note();
    },

    delete_note_line: async function () {
      this.$emit("update_note", null);
      this.close_add_note();
    },
  },
};
</script>

<style scoped>
.my-toast {
  font-size: 5em;
}
.modal {
  display: block;
  padding-right: 17px;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

textarea {
  width: 100%;
  height: 100px;
}
</style>
